module.exports = __webpack_public_path__ + "static/meda-provider5-2c1e40da2188acbdc594ee60a9925f54.png";